/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import configureStore from './store';

import RootErrorBoundary from './components/errors/RootErrorBoundary';
import AppContainer from './components/AppContainer';
import './styles/index.scss';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({ dsn: process.env.SENTRY_DSN });
}

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render((
  <Provider store={configureStore()}>
    <BrowserRouter>
      <RootErrorBoundary>
        <AppContainer />
      </RootErrorBoundary>
    </BrowserRouter>
  </Provider>
));
